import { useAuth } from './useAuth';

export const useRoles = () => {
    const { user } = useAuth();

    const hasRole = (roleName: string): boolean => {
        if (!user || !user.roles) return false;
        return user.roles.some((role) => role.name === roleName);
    };

    const hasAnyRole = (roleNames: string[]): boolean => {
        return roleNames.some((roleName) => hasRole(roleName));
    };

    const hasAllRoles = (roleNames: string[]): boolean => {
        return roleNames.every((roleName) => hasRole(roleName));
    };

    const isAdmin = (): boolean => {
        return hasRole('admin') || hasRole('super_admin');
    };

    const isSuperAdmin = (): boolean => {
        return hasRole('super_admin');
    };

    const isUser = (): boolean => {
        return hasRole('user');
    };

    const hasElevatedAccess = (): boolean => {
        return isAdmin() || isSuperAdmin();
    };

    const getRoleNames = (): string[] => {
        return user?.roles?.map((role) => role.name) || [];
    };

    return {
        hasRole,
        hasAnyRole,
        hasAllRoles,
        isAdmin,
        isSuperAdmin,
        isUser,
        hasElevatedAccess,
        getRoleNames,
        roles: user?.roles || [],
    };
};
